module.exports = __webpack_public_path__ + "96540fdc24d8999a2a12590662ae3a36.pdf";